/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { adminActionLogControllerCreate } from '../fn/admin-action-log/admin-action-log-controller-create';
import { AdminActionLogControllerCreate$Params } from '../fn/admin-action-log/admin-action-log-controller-create';
import { adminActionLogControllerFindAll } from '../fn/admin-action-log/admin-action-log-controller-find-all';
import { AdminActionLogControllerFindAll$Params } from '../fn/admin-action-log/admin-action-log-controller-find-all';
import { adminActionLogControllerFindById } from '../fn/admin-action-log/admin-action-log-controller-find-by-id';
import { AdminActionLogControllerFindById$Params } from '../fn/admin-action-log/admin-action-log-controller-find-by-id';
import { adminActionLogControllerSearchOffset } from '../fn/admin-action-log/admin-action-log-controller-search-offset';
import { AdminActionLogControllerSearchOffset$Params } from '../fn/admin-action-log/admin-action-log-controller-search-offset';
import { AdminActionLogDto } from '../models/admin-action-log-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class AdminActionLogService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `adminActionLogControllerFindAll()` */
  static readonly AdminActionLogControllerFindAllPath = '/api/admin-action-log';

  /**
   * 관리자 로그 전체 조회.
   *
   * 관리자 로그 전체를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminActionLogControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminActionLogControllerFindAll$Response(params?: AdminActionLogControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AdminActionLogDto>>> {
    return adminActionLogControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 로그 전체 조회.
   *
   * 관리자 로그 전체를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminActionLogControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminActionLogControllerFindAll(params?: AdminActionLogControllerFindAll$Params, context?: HttpContext): Observable<Array<AdminActionLogDto>> {
    return this.adminActionLogControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AdminActionLogDto>>): Array<AdminActionLogDto> => r.body)
    );
  }

  /** Path part for operation `adminActionLogControllerCreate()` */
  static readonly AdminActionLogControllerCreatePath = '/api/admin-action-log';

  /**
   * 관리자 로그 생성.
   *
   * 관리자 로그을(를) 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminActionLogControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminActionLogControllerCreate$Response(params: AdminActionLogControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminActionLogDto>> {
    return adminActionLogControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 로그 생성.
   *
   * 관리자 로그을(를) 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminActionLogControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminActionLogControllerCreate(params: AdminActionLogControllerCreate$Params, context?: HttpContext): Observable<AdminActionLogDto> {
    return this.adminActionLogControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdminActionLogDto>): AdminActionLogDto => r.body)
    );
  }

  /** Path part for operation `adminActionLogControllerSearchOffset()` */
  static readonly AdminActionLogControllerSearchOffsetPath = '/api/admin-action-log/search/offset';

  /**
   * 관리자 로그 오프셋 기반 조회.
   *
   * 관리자 로그을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminActionLogControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminActionLogControllerSearchOffset$Response(params: AdminActionLogControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return adminActionLogControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 로그 오프셋 기반 조회.
   *
   * 관리자 로그을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminActionLogControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminActionLogControllerSearchOffset(params: AdminActionLogControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.adminActionLogControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `adminActionLogControllerFindById()` */
  static readonly AdminActionLogControllerFindByIdPath = '/api/admin-action-log/{id}';

  /**
   * 관리자 로그 ID 기반 조회.
   *
   * 관리자 로그을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminActionLogControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminActionLogControllerFindById$Response(params: AdminActionLogControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminActionLogDto>> {
    return adminActionLogControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 로그 ID 기반 조회.
   *
   * 관리자 로그을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminActionLogControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminActionLogControllerFindById(params: AdminActionLogControllerFindById$Params, context?: HttpContext): Observable<AdminActionLogDto> {
    return this.adminActionLogControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdminActionLogDto>): AdminActionLogDto => r.body)
    );
  }

}
